import { type ApiRequisition } from '@Model';
import {
    type AsyncStateUpdate,
    defineWizardStep,
    type MetaData,
    type WizardStep,
} from '@synqo/frontend-component-library';
import { type ContainerPosition } from '../../containerOrder';
import { type RequisitionAction } from '@utils/requisitionAction';
import { type RequisitionWizardState } from '../../RequisitionWizardState';
import { SummaryStepBody, type SummaryStepErrorKey } from './SummaryStepBody';

interface DefineSummaryStepProps {
    data: ApiRequisition;
    meta: MetaData<ApiRequisition> | undefined;
    canEdit: boolean;
    /** The action the order carries, where the wizard knows one. */
    action?: RequisitionAction;
    /** The containers of the order, empty while it carries none. */
    containerPositions?: readonly ContainerPosition[];
    /**
     * Index of the step the "Ändern" link on the positions card leads back to. Defaults to the
     * positions step of the three-step wizard.
     */
    detailsStepIndex?: number;

    requestUpdateState: AsyncStateUpdate<ApiRequisition>;
    i18n: (key: string) => string;
}

// @ai-generated 2026-05-28T11:12:05+00:00 by matthias.gessinger@synqony.com using Claude Opus 4.7
export function defineSummaryStep(props: DefineSummaryStepProps): WizardStep<RequisitionWizardState> {
    const i18n = props.i18n;
    return defineWizardStep<RequisitionWizardState, SummaryStepErrorKey>({
        key: 'summary',
        label: i18n('Zusammenfassung'),
        render: () => <SummaryStepBody {...props} />,
        validate: (feState) => {
            const errors: Partial<Record<SummaryStepErrorKey, string>> = {};
            if (!feState.termsAccepted) {
                errors.termsAccepted = i18n('Bitte akzeptiere die AGB, um die Bestellung abzuschicken.');
            }
            return errors;
        },
    });
}
